// Google Auth (Emergent managed OAuth) — global auth store.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const API = process.env.REACT_APP_BACKEND_URL;

class AuthStore {
    constructor() {
        this.state = { status: "checking", user: null }; // checking | guest | authed
        this.listeners = new Set();
    }

    subscribe(fn) {
        this.listeners.add(fn);
        fn(this.state);
        return () => this.listeners.delete(fn);
    }

    set(patch) {
        this.state = { ...this.state, ...patch };
        this.listeners.forEach((f) => f(this.state));
    }

    login() {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const redirectUrl = window.location.origin + window.location.pathname;
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    }

    async exchange(sessionId) {
        const r = await fetch(`${API}/api/auth/session`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({ session_id: sessionId }),
        });
        if (!r.ok) throw new Error("session exchange failed");
        const user = await r.json();
        this.set({ status: "authed", user });
        return user;
    }

    async check() {
        try {
            const r = await fetch(`${API}/api/auth/me`, { credentials: "include" });
            if (!r.ok) throw new Error("401");
            const user = await r.json();
            this.set({ status: "authed", user });
        } catch {
            this.set({ status: "guest", user: null });
        }
    }

    async register(email, password, name, instagram, accountType = "client") {
        const r = await fetch(`${API}/api/auth/register`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({ email, password, name, instagram, account_type: accountType }),
        });
        if (!r.ok) throw new Error((await r.json()).detail || "Inscription impossible");
        const user = await r.json();
        this.set({ status: "authed", user });
        return user;
    }

    async loginPassword(email, password) {
        const r = await fetch(`${API}/api/auth/login-password`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({ email, password }),
        });
        if (!r.ok) throw new Error((await r.json()).detail || "Connexion impossible");
        const user = await r.json();
        this.set({ status: "authed", user });
        return user;
    }

    async logout() {
        await fetch(`${API}/api/auth/logout`, { method: "POST", credentials: "include" });
        this.set({ status: "guest", user: null });
    }

    // Thin wrapper around fetch that always sends the session cookie.
    fetch(url, options = {}) {
        return fetch(url, { ...options, credentials: "include" });
    }
}

export const auth = new AuthStore();
